import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { WorkloadApi } from './api.interface';
import CustomError from '../../components/shared/error-handling/error';
import { CreateWorkloadRequest } from './dto/request/create-workload.request';
import { GetWorkloadsRoot } from './dto/response/get-workloads.response';
import { CreateWorkloadRoot } from './dto/response/create-workload.response';
import { GetPipelineLog } from './dto/response/get-pipeline-log.response';
import { ScmAuthApi } from '@backstage/integration-react';

export class WorkloadApiClient implements WorkloadApi {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
    scmAuthApi: ScmAuthApi;

    constructor({ discoveryApi, identityApi, scmAuthApi }: { discoveryApi: DiscoveryApi, identityApi: IdentityApi, scmAuthApi: ScmAuthApi }) {
        this.discoveryApi = discoveryApi;
        this.identityApi = identityApi;
        this.scmAuthApi = scmAuthApi;
    }
  
    private async fetch<T = any>(input: string, init?: RequestInit): Promise<T> {
        const proxyUri = `${await this.discoveryApi.getBaseUrl('proxy')}/workload/deploy`;
        const gitlabUrl = await this.discoveryApi.getBaseUrl('gitlab');

        const token = (await this.identityApi.getCredentials()).token;
        let userCredentials = (await this.scmAuthApi.getCredentials({ instantPopup: false, optional: true, url: gitlabUrl, additionalScope: { customScopes: { gitlab: ['api'] } } }));
        if (!userCredentials.token)
            userCredentials = (await this.scmAuthApi.getCredentials({ instantPopup: false, url: gitlabUrl, additionalScope: { customScopes: { gitlab: ['api'] } } }));

        const headers = {
            ...init?.headers,
            'Authorization': `Bearer ${token}`,
            'User-Authorization': `Bearer ${userCredentials.token}`,
            'Content-Type': 'application/json'
        };
    
        // Create a new init object with merged headers
        const newInit: RequestInit = {
            ...init,
            headers: headers
        };

        // As configured previously for the backend proxy
        const resp = await fetch(`${proxyUri}${input}`, newInit);
        if (!resp.ok) {
            throw new CustomError(`Error ${resp.status}: ${resp.statusText}`, resp.status);
        }
        return await resp.json();
    }

    async getWorkloads (environment: string, system_name: string, application_name: string): Promise<GetWorkloadsRoot> {
        return await this.fetch<GetWorkloadsRoot>(`/environment/${environment}/system/${system_name}/application/${application_name}`);
    }

    async getPipelineLog (environment: string, system_name: string, application_name: string, pipeline_id: number): Promise<GetPipelineLog> {
        return await this.fetch<GetPipelineLog>(`/environment/${environment}/system/${system_name}/application/${application_name}/pipeline/${pipeline_id}/log`);
    }

    async createWorkloadDeploy (environment: string, system_name: string, body: CreateWorkloadRequest): Promise<CreateWorkloadRoot> {
        return await this.fetch<CreateWorkloadRoot>(`/environment/${environment}/system/${system_name}/application`, {
            method: 'POST', headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        });
    }
}